__webpack_require__.p = "https://games.icc-cricket.com/static-assets/top-picks/static/build/";